import React from 'react'
import { Box, PseudoBox, Flex } from '@chakra-ui/core'
import useLocaleText from 'components/useLocaleText'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface PaginationProps {
  canPreviousPage: boolean
  canNextPage: boolean
  pageIndex: number
  pageOptions: number[]
  previousPage: () => void
  nextPage: () => void
}

export const Pagination: React.FC<PaginationProps> = ({
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  previousPage,
  nextPage,
}) => {
  const isRtl = useSelector(isRtlSelector)
  const t_page = useLocaleText('page')
  const t_of = useLocaleText('out_of')
  return (
    <Flex mt={4} justify="space-between" align="center">
      <Flex align="center" style={{ columnGap: '10px' }}>
        <PseudoBox
          as="button"
          key="previous-page"
          onClick={() => previousPage()}
          opacity={canPreviousPage ? 1 : 0.5}
          _disabled={{ cursor: 'not-allowed' }}
          bg={canPreviousPage ? 'gray.200' : 'gray.100'}
          color={canPreviousPage ? 'gray.800' : 'gray.400'}
          px={3}
          py={1}
          rounded="md"
          mr={2}
        >
          {isRtl ? <ChevronRight /> : <ChevronLeft />}
        </PseudoBox>
        <PseudoBox
          as="button"
          key="next-page"
          onClick={() => nextPage()}
          opacity={canNextPage ? 1 : 0.5}
          _disabled={{ cursor: 'not-allowed' }}
          bg={canNextPage ? 'gray.200' : 'gray.100'}
          color={canNextPage ? 'gray.800' : 'gray.400'}
          px={3}
          py={1}
          rounded="md"
        >
          {isRtl ? <ChevronLeft /> : <ChevronRight />}
        </PseudoBox>
      </Flex>
      {pageOptions.length > 0 && (
        <Box>
          {t_page} {pageIndex + 1} {t_of} {pageOptions.length}
        </Box>
      )}
    </Flex>
  )
}
